// Only import type in development, we'll dynamically import the actual SDK in production
import { DevLogger } from './dev-logger';

// Abstract logger interface
interface ILogger {
  info(message: string, meta?: Record<string, any>): void;
  warn(message: string, meta?: Record<string, any>): void;
  error(message: string, meta?: Record<string, any>): void;
}

// Create development logger by default
const defaultLogger: ILogger = new DevLogger();

let logger: ILogger = defaultLogger;

export const initLogger = async (): Promise<void> => {
  const env = import.meta.env.MODE || 'development';
  const cloudwatchEnabled = import.meta.env.VITE_CLOUDWATCH_ENABLED === 'true';
  
  if (env === 'production' && cloudwatchEnabled) {
    try {
      const { ProdLogger } = await import('./prod-logger');
      const prodLogger = new ProdLogger(
        import.meta.env.VITE_AWS_REGION || 'us-east-1',
        import.meta.env.VITE_CLOUDWATCH_LOG_GROUP || '/frontend/logs'
      );
      await prodLogger.initialize();
      logger = prodLogger;
    } catch (error) {
      console.warn('Failed to initialize production logger, using development logger', error);
    }
  }
};

// Initialize logger but don't block
initLogger().catch(console.error);

// Export the logger instance
export { logger }; 